import _ from 'lodash';
import { Box, Stack, useTheme, Typography } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
import { CenteredNarrowContent } from 'theme/elements/Content';
import FormItems, { formItemsType } from 'components/formElements/FormItems';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import { FormInputsTypes } from '../../../constants/settings.constants';
import { languagesHebrew } from 'constants/translation.constants';

export default function UserInfoCard({ handleEdit, userADInfo, contactLanguage, contactPermission, userDetails }) {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const contactName =
		localStorage.getItem('language') === 'he'
			? `${userDetails?.firstNameHebrew} ${userDetails?.lastNameHebrew}`
			: `${userDetails?.firstName} ${userDetails?.lastName}`;

	const hideEmail = (email) => {
		return email.replace(/(\w{2})[\w.-]+@([\w.]+\w)/, `$1${'*'.repeat(email.split('@')[0].length - 2)}@$2`);
	};
	const hidePhone = (phone) => {
		return `${'*'.repeat(3)} - ${'*'.repeat(2)}${phone?.substr(-5)}`;
	};

	const prefixFields = 'page.settings.my_profile.';
	const imageUrl = useAppSelector(selectImageUrl);
	const formEditableItems: formItemsType[] = [
		{
			title: `${t(prefixFields + 'personal_info.title')}`,
			contents: [
				{
					icon: imageUrl(prefixFields + 'personal_info.contact_name.icon') || (
						<PersonOutlineOutlinedIcon sx={{ width: '55%' }} />
					),
					text: contactName,
					type: FormInputsTypes.NAME,
				},
			],
		},
		{
			title: `${t(prefixFields + 'contact_information.title')}`,
			contents: [
				{
					icon: imageUrl(prefixFields + 'contact_information.email.icon') || (
						<EmailOutlinedIcon sx={{ width: '55%' }} />
					),
					text: hideEmail(userADInfo?.email),
					type: FormInputsTypes.EMAIL,
					disable: true,
				},
				{
					icon: imageUrl(prefixFields + 'contact_information.phone.icon') || (
						<CallOutlinedIcon sx={{ width: '55%' }} />
					),
					text: hidePhone(userADInfo?.phone),
					type: FormInputsTypes.PHONE,
					disable: true,
				},
			],
		},
		{
			title: `${t(prefixFields + 'language.title')}`,
			contents: [
				{
					icon: imageUrl(prefixFields + 'language.icon') || <TranslateOutlinedIcon sx={{ width: '55%' }} />,
					text: contactLanguage === 'en' ? contactLanguage : languagesHebrew[contactLanguage],
					type: FormInputsTypes.LANGUAGE,
				},
			],
		},
	];

	return (
		<Box>
			<Stack>
				<CenteredNarrowContent>
					<FormCard>
						<FormHeader1 title={contactName} />
						<Box
							sx={{
								margin: '0 32px 0 0!important',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								width: '100px',
								color: theme.palette.root.ux07777,
							}}
						>
							<Typography sx={{ fontWeight: 600 }}>{userADInfo.role}</Typography>
							<Typography sx={{ fontWeight: 600 }}>&#x2022;</Typography>
							<Typography sx={{ fontWeight: 600 }}>
								{t(
									'page.settings.contacts.permission.' +
										`${contactPermission.toLowerCase()}` +
										'.text'
								) || contactPermission}
							</Typography>
						</Box>
						<Box>
							{formEditableItems &&
								formEditableItems.map((item, index) => {
									return (
										<FormItems
											key={index}
											item={item}
											handleEdit={handleEdit}
											editButtonLabelPrefix={prefixFields}
										/>
									);
								})}
						</Box>
					</FormCard>
				</CenteredNarrowContent>
			</Stack>
		</Box>
	);
}
